import type { RenderContext, VideoFrame } from '../../types';
import { BaseEffect } from '../base';
import { stableEffectSeed, withOverlay } from './composite';
import { buildDustParticles, drawDust } from '../../particles/engine';

const DEFAULTS = { density: 0.4, speed: 0.1 };

export class DustParticlesEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'dust_particles', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    return this.renderCpu(frame, params, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const seed = stableEffectSeed(context, this.id);
    const particles = buildDustParticles(
      frame.width, frame.height, params.density, params.speed,
      context.frameIndex, seed,
    );
    return withOverlay(frame, (ctx) => drawDust(ctx, particles), 'screen');
  }
}
